import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "../lib/api";
import { useApi } from "../hooks/useApi";
import { ukDateTime } from "../lib/format";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";

export function NotificationBell() {
  const { data, reload } = useApi("/notifications");
  const navigate = useNavigate();
  const unread = data?.unread || 0;
  return (
    <DropdownMenu onOpenChange={async (o) => { if (!o && unread) { await api.post("/notifications/read-all"); reload(true); } }}>
      <DropdownMenuTrigger asChild>
        <button className="relative grid h-9 w-9 place-items-center rounded-md hover:bg-muted" data-testid="notification-bell" aria-label="Notifications">
          <Bell className="h-5 w-5" />
          {unread > 0 && <span className="absolute -right-0.5 -top-0.5 grid h-5 min-w-5 place-items-center rounded-full bg-primary px-1 text-[10px] font-bold text-primary-foreground" data-testid="notification-unread-count">{unread}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 max-h-96 overflow-y-auto">
        <DropdownMenuLabel>Notifications</DropdownMenuLabel><DropdownMenuSeparator />
        {(data?.items || []).length === 0 && <div className="px-2 py-4 text-sm text-muted-foreground">You're all caught up.</div>}
        {(data?.items || []).map((n) => (
          <DropdownMenuItem key={n.id} onClick={() => navigate(n.link)} className={`flex-col items-start gap-0.5 ${n.read ? "" : "bg-accent/50"}`} data-testid="notification-item">
            <span className="text-sm font-semibold">{n.title}</span><span className="text-xs text-muted-foreground">{n.body}</span><span className="text-[10px] text-muted-foreground">{ukDateTime(n.at)}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
